export default __webpack_public_path__ + "static/media/Buildingrip33.2b270387.svg";